{
  "brand": {
    "butter": "#FFD84D",
    "pink": "#FF8DB6",
    "mint": "#7BE0C0",
    "sky": "#8FC3FF",
    "live": "#FF3F63",
    "onColor": "#1A1538"
  },
  "modes": {
    "light": {
      "bg": "#F2F0FB",
      "surface": "#FFFFFF",
      "surface2": "#F6F4FD",
      "sidebar": "#FFFFFF",
      "text": "#1A1538",
      "textMuted": "#5E5980",
      "outline": "#1A1538",
      "controlBorder": "#1A1538",
      "hairline": "#E4E0F2",
      "chip": "#EEEAFB",
      "chipText": "#3B3560",
      "red": "#D13438",
      "onRed": "#FFFFFF",
      "focus": "#1A1538",
      "successText": "#0F7A55",
      "warningText": "#8A5A00",
      "infoText": "#1F5FAF"
    },
    "dark": {
      "bg": "#1A1633",
      "surface": "#272150",
      "surface2": "#2F2960",
      "sidebar": "#1F1A3D",
      "text": "#F4F1FF",
      "textMuted": "#ADA7CE",
      "outline": "#0B0919",
      "controlBorder": "#8A82C0",
      "hairline": "#3A3370",
      "chip": "#342D68",
      "chipText": "#DCD7F7",
      "red": "#FF6B6F",
      "onRed": "#1A1538",
      "focus": "#FFD84D",
      "successText": "#7BE0C0",
      "warningText": "#FFD84D",
      "infoText": "#8FC3FF"
    }
  },
  "font": {
    "display": "'Dela Gothic One', 'Kanit', 'Anuphan Variable', sans-serif",
    "body": "'Rubik Variable', 'Anuphan Variable', system-ui, sans-serif"
  },
  "radius": { "button": 12, "panel": 18, "thumb": 14, "pill": 999 },
  "space": { "xs": 4, "sm": 8, "md": 16, "lg": 24, "xl": 32, "2xl": 48, "3xl": 64 },
  "motion": {
    "fast": "150ms cubic-bezier(0.16, 1, 0.3, 1)",
    "normal": "300ms cubic-bezier(0.16, 1, 0.3, 1)",
    "slow": "500ms cubic-bezier(0.16, 1, 0.3, 1)"
  },
  "levels": {
    "loud": { "outline": 3, "panelShadow": 6, "buttonShadow": 4 },
    "working": { "outline": 2, "panelShadow": 4, "buttonShadow": 3 },
    "serious": { "outline": 2, "panelShadow": 4, "buttonShadow": 3, "edge": 10 }
  },
  "size": {
    "fontSize": 14,
    "fontSizeThai": 15,
    "lineHeight": 1.5,
    "lineHeightThai": 1.6,
    "controlHeight": 40
  }
}
